import React, {useState} from "react";
import contactService from "../../services/contactService.js";
import inputStyles from '../../styles/module/Input.module.css';
import styles from "../../styles/module/SectionFindTable.module.css"; // Import Input.module.css

const Form = (props) =>{
    const [isSubmitting, setIsSubmitting] = useState(false); // Thêm trạng thái submitting
    const [submissionError, setSubmissionError] = useState(null); // Thêm trạng thái lỗi submit

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: '',
    });

    const [errors, setErrors] = useState({
        name: '',
        phone: '',
        email: '',
    });

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {...errors};

        if (!formData.name.trim()) {
            newErrors.name = 'Bitte geben Sie Ihren Namen ein.';
            isValid = false;
        } else {
            newErrors.name = '';
        }

        if (!formData.phone.trim()) {
            newErrors.phone = 'Bitte geben Sie Ihre Telefonnummer ein.';
            isValid = false;
        } else if (!/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(formData.phone)) {
            newErrors.phone = 'Bitte geben Sie eine gültige Telefonnummer ein.';
            isValid = false;
        } else {
            newErrors.phone = '';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'Bitte geben Sie Ihre E-Mail-Adresse ein.';
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
            isValid = false;
        } else {
            newErrors.email = '';
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setIsSubmitting(true); // Bắt đầu submitting
            setSubmissionError(null); // Reset lỗi submit

            try {

                const responseData = await contactService.createContact({
                    name: formData?.name,
                    phoneNumber: formData?.phone,
                    email: formData?.email,
                    message:  formData?.message,
                    tenant:"KANDO"
                });
                console.log('Reservation created successfully:', responseData);

                // Reset form sau khi submit thành công
                setFormData({
                    name: '',
                    phone: '',
                    email: '',
                    message: '',
                });
                setErrors({}); // Xóa errors
                alert('Kontakt erfolgreich erstellt'); // Hiển thị thông báo thành công (sử dụng i18next)
            } catch (error) {
                console.error('Error submitting form:', error);
                setSubmissionError("Kontakterstellung fehlgeschlagen"); // Hiển thị thông báo lỗi (sử dụng i18next)

                // Xử lý lỗi từ API (ví dụ: lỗi validation từ server)
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors); // Cập nhật trạng thái lỗi với lỗi từ server
                }
            } finally {
                setIsSubmitting(false); // Kết thúc submitting (dù thành công hay thất bại)
            }

            setErrors({}); // Reset errors sau khi submit thành công
        } else {
            console.log('Form has errors.');
        }
    };

    return (
        <form action="" className={`${styles.formContainer}`} onSubmit={handleSubmit}>
            <div className={`${styles.headline2} ${styles.textCenter}`}>Kontaktieren Sie uns</div>
            <div className={`${styles.formText} ${styles.textCenter}`}>Bitte füllen Sie alle Angaben aus</div>
            {submissionError && <div className={`${styles.errorMessage}`}>{submissionError}</div>}

            <div className={`${styles.inputWrapper}`}>
                <div className={`${styles.inputContainer}`}>
                    <input
                        type="text"
                        name="name"
                        placeholder="Ihr Name"
                        autoComplete="off"
                        className={inputStyles.inputField}
                        value={formData.name}
                        onChange={handleChange}
                    />
                    {errors.name &&  <div className={`${styles.errorMessage}`}>{errors.name}</div>}
                </div>
                <div className={`${styles.inputContainer}`}>
                    <input
                        type="tel"
                        name="phone"
                        placeholder="Telefonnummer"
                        autoComplete="off"
                        className={inputStyles.inputField}
                        value={formData.phone}
                        onChange={handleChange}
                    />
                    {errors.phone && <div className={`${styles.errorMessage}`}>{errors.phone}</div>}
                </div>
                <div className={`${styles.inputContainer}`}>
                    <input
                        type="email"
                        name="email"
                        placeholder="E-Mail"
                        autoComplete="off"
                        className={inputStyles.inputField}
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {errors.email && <div className={`${styles.errorMessage}`}>{errors.email}</div>}
                </div>

            </div>

            <textarea
                name="message"
                placeholder="Nachricht"
                autoComplete="off"
                className={inputStyles.inputField}
                value={formData.message}
                onChange={handleChange}
            />
            <button disabled={isSubmitting} type="submit" className={`hover-filled-slide-right ${styles.actionSend}`}
            >
                <span> Senden</span>
            </button>
        </form>
    )
}

export default Form